<ng-container>
    <div #mapbox id="mapbox" class="grabbable mapbox-root"></div>
</ng-container>
<qm-marker *ngFor="let feature of markers; trackBy: trackByFn" [feature]="feature"></qm-marker>
<qm-hover></qm-hover>
